import React, {Component} from 'react';
import { Redirect } from "react-router-dom";
import MetaTags from 'react-meta-tags'

// Components
import Anime from '../../components/Anime/Anime';
import Button from '../../components/Button/Button';
import BrowserThumb from '../../components/BrowserThumb/BrowserThumb';

// Containers
import StandardFeatures from '../../containers/StandardFeatures/StandardFeatures';
import Themes from '../../containers/Themes/Themes';
import Hero from '../../containers/Hero/Hero';
import HeroLayer from '../../containers/Hero/HeroLayer';

// Data
import Data from '../../data/Themes.json';


class ThemePattern extends Component {

	render() {
		const themeData = this.props.theme;
		return (
			<div className="app-section mb-md">
                    <MetaTags>
                        <title>{themeData.meta.title}</title>
                        <meta name="description" content={themeData.meta.description} />
                    </MetaTags>

                <Hero height="auto" classes="hero-page">
                	<div className="container theme">
		            	<div className="row row-large-gutter  align-items-center">

                            <div className="col-12 col-xl-5 col-lg-5 ">
                            	<Anime type="fade-up" delay="1" duration="3">
                            		<h1 className="theme__title">{themeData.title}</h1>
                            	</Anime>
                            	<Anime type="fade-up" delay="2" duration="3">
                            		<h2 className="theme__subtitle">{themeData.subTitle}</h2>
                            	</Anime>
                            	<Anime type="fade-up" delay="3" duration="3">
                            		<p className="theme__desc">{themeData.description}</p>
                            	</Anime>
                            	<Anime type="fade-up" delay="4" duration="3">
	                            	<div className="theme__buttons">
	                        		 	<Button 
											title="Preview"
											link={themeData.previewLink}
											icon=""
											classes="btn-preview big outline shadow"
	                        			/>
	                        			<Button 
											title="Buy Now"
											link={themeData.shopLink}
											icon=""
											classes="btn-buy big shadow"
	                        			/>
	                            	</div>
                            	</Anime>
                            </div>

                         	<div className="col-12 col-xl-7 col-lg-7">
                         		<Anime type="fade-up" delay="3" duration="3">
	                         	 	<BrowserThumb 
										title={themeData.title}
										link=""
										src={themeData.thumb}
										srcLow={themeData.thumbLow} 
										imageAlt={themeData.title}
										bgColor="#000000"
										width="1000"
										height="1100" 
										classes="theme__thumb shadow"
									/>
								</Anime>
                             </div>
		            	</div>
	                </div>

		            <HeroLayer
	                	classes="lines-bg anim anim--fade anim--duration-8 anim--delay-1"
	                	styleOuter={{
	                		zIndex:1
	                	}}
	                	styleInner={{
	                		top: 0,
	                		bottom: 0,
	                		left:0,
	                		right:0,
	                		opacity:0.6,
                    		backgroundSize: "cover",
	                		backgroundImage: "url(https://rascalsthemes.com/images/dark-texture.jpg)",
	                	}}
	                />
            	</Hero>

                <div className="container">

					<Anime type="fade" delay="2" duration="5">
	                    <StandardFeatures title="Theme Standard Features" classes="mb2 mb-sm" />
	                    
	                    <Themes title="More Themes" limit="3" exclude={themeData.title} grid="col-12 col-md-4 mb2-md" classes="mb mb-sm" />
	                </Anime>

                </div>
            </div>

		)
	}
}

class Theme extends Component {


    render () {

    	const specificTheme = this.props.match.params.ThemeName;
    	const themeData = Data[specificTheme];

    	if ( themeData !== undefined ) {
	        return (
	           <ThemePattern theme={themeData} />
	        );

	    } else {
    		return (
    			<Redirect from="theme/*" to="/themes" />
    		);
	    }
    }
}

export default Theme;


// WEBPACK FOOTER //
// ./src/containers/Theme/Theme.js